import { render, staticRenderFns } from "./NotificationCreateTab.vue?vue&type=template&id=2cd6984e&scoped=true&"
import script from "./NotificationCreateTab.vue?vue&type=script&lang=js&"
export * from "./NotificationCreateTab.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCreateTab.vue?vue&type=style&index=0&id=2cd6984e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd6984e",
  null
  
)

export default component.exports